import React from "react";

function PaddingTile() {
    return (
        <div className="padding-tile"></div>
    )   
}
export default PaddingTile